var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_view)?_c('Layout',{attrs:{"user":_vm.user,"member_info":_vm.user,"codes":_vm.codes,"shop_info":_vm.shop_info,"category_list":_vm.category_list}}):_c('Loading')
}
var staticRenderFns = []

export { render, staticRenderFns }